import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyB2HcrxczBQ0RH3i5dbh1uws2vR7HJ8od4",
  authDomain: "vivashri-6774d.firebaseapp.com",
  projectId: "vivashri-6774d",
  storageBucket: "vivashri-6774d.firebasestorage.app",
  messagingSenderId: "916653873249",
  appId: "1:916653873249:web:6f6d6b4949fdfac7453220",
  measurementId: "G-G9M0WQR1SS"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);